import React from 'react';
import SunIcon from '../../SunIcon.jsx';

function CareerOutlook(props) {
  const { plainText, modalStyling, titleTextPrimary, setParentOnClick } = {
    ...props,
  };

  return (
    <div className="career-outlook-icon-container">
      <div className="career-outlook-sun-icon">
        <SunIcon showSpeechBubble={false} setParentOnClick={setParentOnClick} />
      </div>
      <p
        className="onestop-plain-text career-outlook"
        style={modalStyling ? titleTextPrimary : null}
      >
        {plainText}
      </p>
    </div>
  );
}

export default CareerOutlook;
